require('./bootstrap');

require('flatpickr');
require('flatpickr/dist/themes/material_blue.css');
import 'alpinejs';

window.autosize = require('autosize');
window.Tourn.vendor.flash.init();
